import { render, staticRenderFns } from "./OsCreateTargetProfileGuidedCreation.vue?vue&type=template&id=34ab2c84&scoped=true"
import script from "./OsCreateTargetProfileGuidedCreation.vue?vue&type=script&lang=ts"
export * from "./OsCreateTargetProfileGuidedCreation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ab2c84",
  null
  
)

export default component.exports